import React from 'react'
import * as calStyles from '../../styles/project-modules/bills/calendar.module.less'
import { convertDatesToAP } from '../sfc/component-helpers/datehelpers'

function Calendar({ date, time, location, description }) {
  const machine_date = new Date(`${date} ${time}`)
  const ISO_DATE = machine_date.toISOString()
  const dateString = convertDatesToAP(
    machine_date.toLocaleString('en-US', {
      dateStyle: 'long',
    })
  )
  const timeString = convertDatesToAP(
    machine_date.toLocaleString('en-US', {
      timeStyle: 'short',
    })
  )
  return (
    <div className={calStyles.container}>
      <time className={calStyles.dateTime} datetime={ISO_DATE}>
        {dateString}
      </time>
      <h4 className={calStyles.description}>{description}</h4>
      <p className={calStyles.location}>
        {location} at {timeString}
      </p>
    </div>
  )
}

export default Calendar
